/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CompanyProfile } from '../models/company-profile';
import { CompanySearchResult } from '../models/company-search-result';

@Injectable({
  providedIn: 'root',
})
export class CompanyInfoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findCompanies
   */
  static readonly FindCompaniesPath = '/api/v1/CompanyInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCompanies$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCompanies$Plain$Response(params?: {
    tradeName?: string;
    count?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<CompanySearchResult>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyInfoService.FindCompaniesPath, 'get');
    if (params) {
      rb.query('tradeName', params.tradeName, {});
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CompanySearchResult>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findCompanies$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCompanies$Plain(params?: {
    tradeName?: string;
    count?: number;
  },
  context?: HttpContext

): Observable<Array<CompanySearchResult>> {

    return this.findCompanies$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<CompanySearchResult>>) => r.body as Array<CompanySearchResult>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCompanies$Response(params?: {
    tradeName?: string;
    count?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<CompanySearchResult>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyInfoService.FindCompaniesPath, 'get');
    if (params) {
      rb.query('tradeName', params.tradeName, {});
      rb.query('count', params.count, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CompanySearchResult>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCompanies(params?: {
    tradeName?: string;
    count?: number;
  },
  context?: HttpContext

): Observable<Array<CompanySearchResult>> {

    return this.findCompanies$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<CompanySearchResult>>) => r.body as Array<CompanySearchResult>)
    );
  }

  /**
   * Path part for operation getCompanyProfile
   */
  static readonly GetCompanyProfilePath = '/api/v1/CompanyInfo/Profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyProfile$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyProfile$Plain$Response(params?: {
    chamberOfCommerceNumber?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CompanyProfile>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyInfoService.GetCompanyProfilePath, 'get');
    if (params) {
      rb.query('chamberOfCommerceNumber', params.chamberOfCommerceNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyProfile>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyProfile$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyProfile$Plain(params?: {
    chamberOfCommerceNumber?: string;
  },
  context?: HttpContext

): Observable<CompanyProfile> {

    return this.getCompanyProfile$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<CompanyProfile>) => r.body as CompanyProfile)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyProfile$Response(params?: {
    chamberOfCommerceNumber?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CompanyProfile>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyInfoService.GetCompanyProfilePath, 'get');
    if (params) {
      rb.query('chamberOfCommerceNumber', params.chamberOfCommerceNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyProfile>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyProfile(params?: {
    chamberOfCommerceNumber?: string;
  },
  context?: HttpContext

): Observable<CompanyProfile> {

    return this.getCompanyProfile$Response(params,context).pipe(
      map((r: StrictHttpResponse<CompanyProfile>) => r.body as CompanyProfile)
    );
  }

}
